/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import Drawer from "@mui/material/Drawer";

export const StyledDrawer = styled(({ ...props }) => <Drawer {...props} />)`
  ${({ theme }) => `
    &.product-list-drawer {
      .MuiBackdrop-root {
        background-color:rgba(33, 33, 33, 0.85);
      }
      .MuiDrawer-paper {
        border-radius: 8px 8px 0 0;
        overflow-y: hidden;
        overflow-x: hidden;
        width: 100%;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
      }
      .product-list-drawer-header {
        padding: 16px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #E0E0E0;
        background: #FFF;
        flex-shrink: 0;
      }
      .product-list-drawer-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0 16px;
      }
      .product-list-drawer-footer {
        padding: 16px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        border-top: 1px solid #E0E0E0;
        background: #FFF;
        flex-shrink: 0;
        box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.05);
      }
    }
    &.filter-gallery-drawer {
      .MuiBackdrop-root {
        background-color:rgba(33, 33, 33, 0.6);
      }
      .MuiDrawer-paper {
        border-radius: 8px 8px 0 0;
        background: ${theme.palette.secondary.extraLight};
        padding: ${theme.spacing(5)};
        overflow-y: visible;
      }
    }
`}
`;
